export const InitLensAbi = [
  {
    inputs: [
      {
        internalType: 'uint16',
        name: 'mode',
        type: 'uint16',
      },
    ],
    name: 'getMarketData',
    outputs: [
      {
        components: [
          {
            internalType: 'uint16',
            name: 'mode',
            type: 'uint16',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'underlying',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'collateralFactor',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowFactor',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'maxHealthAfterLiq',
            type: 'uint256',
          },
          {
            internalType: 'uint128',
            name: 'supplyCap',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'borrowCap',
            type: 'uint128',
          },
          {
            internalType: 'bool',
            name: 'canMint',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'canBurn',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'canBorrow',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'canRepay',
            type: 'bool',
          },
          {
            internalType: 'bool',
            name: 'canFlash',
            type: 'bool',
          },
          {
            internalType: 'uint256',
            name: 'totalSupply',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'totalDebt',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyRate',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowRate',
            type: 'uint256',
          },
        ],
        internalType: 'struct MarketData[]',
        name: 'data',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'viewer',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'getUserPositionData',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'posId',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'owner',
            type: 'address',
          },
          {
            internalType: 'uint16',
            name: 'mode',
            type: 'uint16',
          },
          {
            internalType: 'address',
            name: 'approved',
            type: 'address',
          },
          {
            internalType: 'bool',
            name: 'isApprovedForAll',
            type: 'bool',
          },
        ],
        internalType: 'struct PosMeta[]',
        name: 'posMeta',
        type: 'tuple[]',
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'underlying',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
        ],
        internalType: 'struct PosData[][]',
        name: 'collaterals',
        type: 'tuple[][]',
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'underlying',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
        ],
        internalType: 'struct PosData[][]',
        name: 'debts',
        type: 'tuple[][]',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
